module.exports = __webpack_public_path__ + "img/liaoning.ca506cc7.jpg";